import { tap } from 'lodash/fp';
import estimateLoaded from './estimateLoaded';
import globalError from './globalError';
import loaded from './loaded';
import loading from './loading';
import * as designBuilderApi from '../api/designBuilder';

const editMeasurement = (designId, itemId, width, height) => (dispatch) => {
  dispatch(loading());

  return designBuilderApi.editMeasurements(designId, itemId, width, height)
    .then(response => dispatch(estimateLoaded(response.data)))
    .then(tap(() => dispatch(loaded())))
    .catch(err => dispatch(globalError({ err })));
};

export default editMeasurement;
